export enum Visibility {
    Show = 'show',
    Hide = 'hide',
}

const handleVisibility = (visibility: Visibility): string => {
    return visibility === Visibility.Show ? '' : 'display: none';
};

export default handleVisibility;
